import {GPS_PAGE, HOME_PAGE, MENTION_PAGE, SLASH_PAGE, THEME_PAGE} from "../../constants/router";

export default {
    [SLASH_PAGE]: '/',
    [GPS_PAGE]: '/:database/:display',
    [HOME_PAGE]: '/home',
    [THEME_PAGE]: '/theme',
    [MENTION_PAGE]: '/mentions',
}